import React, {useContext, useEffect, useState} from 'react';
import {observer} from "mobx-react-lite";
import {Context} from "../../../index";
import {delGenre, delLanguage, delPrice, fetchGenre, fetchLanguages, fetchPrices} from "../../../http/bookAPI";
import Modal from "react-bootstrap/Modal";
import {Dropdown, Form, Spinner} from "react-bootstrap";

const DeletePrice = observer(({ show, handleClose }) => {
    const {book} = useContext(Context)
    const [value, setValue] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    useEffect(() => {
        fetchPrices().then(data => book.setPrices(data))
    }, []);

    const killPrice = async () => {
        setLoading(true);
        setError('');
        try {
            // Отправляем DELETE запрос с параметром id в URL
            await delPrice(book?.selectedPrice?.id); // Просто передаём ID Price
            const updatedPrices = await fetchPrices(); // Обновляем список жанров
            book.setPrices(updatedPrices);
            book.setSelectedPrice({}); // Сбрасываем выбранный language
            setValue(''); // Очищаем поле ввода
            handleClose(); // Закрываем модальное окно
        } catch (e) {
            const errorMessage = e.response?.data?.message || 'An error occurred while adding the Price.';
            setError(errorMessage);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal show={show} onHide={() => {
            setError('');
            handleClose();
        }} centered>

            <div className="modal-content">
                <div className="modal-header">
                    <h1 className="modal-title fs-5" id="exampleModalLabel">Delete Price:</h1>
                    <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                        onClick={() => {
                            setError('');
                            handleClose();
                        }}
                    ></button>
                </div>

                <div className="card">
                    <div className="card-body">

                        <div className="d-flex justify-content-center mt-3">

                            <Dropdown className="dropdown-center">
                                <Dropdown.Toggle variant="success" className="shadow">
                                    {book?.selectedPrice?.price || "Select Price to Delete"}
                                </Dropdown.Toggle>
                                <Dropdown.Menu>
                                    {book.prices.map((pr) => (
                                        <Dropdown.Item
                                            onClick={() => {book.setSelectedPrice(pr);
                                                setValue(pr.price);
                                            }}
                                            key={pr.id}
                                        >
                                            {pr.price}
                                        </Dropdown.Item>
                                    ))}
                                </Dropdown.Menu>
                            </Dropdown>
                        </div>
                    </div>
                </div>
                <div className="modal-body">
                    {error && <div className="alert alert-danger">{error}</div>}
                    <Form>
                        <Form.Control
                            value={value}
                            onChange={(e) => setValue(e.target.value)}
                            disabled={true} // Отключаем, если ничего не выбрано
                        />
                    </Form>
                </div>
                <div className="modal-footer">

                    <button
                        type="button"
                        className="btn btn-primary"
                        onClick={killPrice}
                        disabled={!value.trim() || loading}
                    >
                        {loading ? <Spinner as="span" animation="border" size="sm"/> : 'Delete from DB'}
                    </button>

                </div>
            </div>
        </Modal>
    );
});



export default DeletePrice;